var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatewayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.863,
    height: 68.233,
    viewBox: "0 0 146.863 68.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M1074.687,3357.675c0,6.383-.053,12.766.038,19.147.026,1.768-.583,2.5-2.317,2.6-1.581.088-3.242.115-3.6,2.35-.072.448-1.216.931-1.915,1.026-1.7.231-3.572.727-5.119.26-5.752-1.725-11.283-.039-16.843.751-14.593,2.073-29.162,4.318-43.724,6.593-1,.156-1.87,1.106-2.8,1.692-.774.485-1.521,1.342-2.325,1.395a78.649,78.649,0,0,1-7.958.025c-.631-.022-1.619-.372-1.806-.83-.979-2.4-3.21-2.3-5.125-2.764-11.052-2.685-22.092-5.422-33.189-7.909-3.058-.685-6.3-.507-9.449-.838-1.923-.2-4.249.37-4.942-2.581-.127-.541-1.769-.855-2.756-1.032a2.047,2.047,0,0,1-1.988-2.4c.058-12.851.017-25.7.043-38.552.006-2.782,2.138-4.443,5.932-4.755q14.695-1.208,29.389-2.4c13.322-1.077,26.627-2.543,39.971-3.055,7.6-.294,15.283.748,22.884,1.594,13.45,1.493,26.868,3.272,40.292,4.993a20.868,20.868,0,0,1,4.451,1.211,4.138,4.138,0,0,1,2.878,4.337C1074.647,3344.911,1074.683,3351.294,1074.687,3357.675Z",
    transform: "translate(-928.363 -3325.859)",
    fill: "#00563a",
    stroke: "#fff",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayIcon);
export default __webpack_public_path__ + "static/media/GatewayIcon.ef28186a84dea0e9a91eaccd11aefe27.svg";
export { ForwardRef as ReactComponent };